export const BASE_TICKS = 1000; // Base number of ticks for small deltas
